export default {
    intro: '뜻을 보고 알맞은 단어를 골라보세요!',
    th: {
        order: '순서',
        meaning: '뜻',
        answer: '정답',
        wrongChoices: '오답선지',
        correctRate: '정답률',
    },
};
